/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit WeeksCompleted/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function WeeksCompleted({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Progress/Content/Content/WeeksCompleted"
  
}) {
let treatmentProgressPercentageValueData = fromData.useDataFormat({ viewPath,
context: 'treatment_progress',
path: 'percentage',
format: fromFormat.percentage,
})
  return (<React.Fragment
>
<div
  data-testid="WeeksCompleted.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="bold"
 data="treatment_progress.percentage"
 format="/Data/format.js percentage"
 text={treatmentProgressPercentageValueData}
/>
</div>
{children}
</React.Fragment>)
}